import { useEffect, useState } from "react";
import { Users, CalendarDays, Megaphone } from "lucide-react";
import axios, { API } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import StatCard from "@/components/shared/StatCard";
import LoadingScreen from "@/components/shared/LoadingScreen";
import EmptyState from "@/components/shared/EmptyState";

function formatDate(d) { return d ? new Date(d).toLocaleDateString("id-ID", { day: "numeric", month: "long", year: "numeric" }) : "-"; }

export default function GuideDashboard() {
  const { user } = useAuth();
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${API}/guide/dashboard`).then(({ data }) => setData(data)).catch(() => setData(null));
  }, []);

  if (!data) return <LoadingScreen />;

  return (
    <div data-testid="guide-dashboard-page" className="space-y-6">
      <div className="rounded-2xl bg-gradient-to-r from-[#0F6B4F] to-[#1677B8] p-7 text-white">
        <h1 className="font-heading text-2xl font-bold">Assalamu'alaikum, {user?.name}</h1>
        <p className="mt-1 text-sm text-white/85">Berikut ringkasan jamaah dan jadwal bimbingan Anda.</p>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        <StatCard testId="guide-stat-total-pilgrims" icon={Users} label="Jamaah Ditugaskan" value={data.total_pilgrims} />
        <StatCard testId="guide-stat-programs" icon={CalendarDays} label="Program Dibimbing" value={data.programs.length} />
        <StatCard testId="guide-stat-manasik" icon={CalendarDays} label="Manasik Mendatang" value={data.upcoming_manasik.length} />
      </div>

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <div className="rounded-2xl bg-white p-5 shadow-[0_2px_10px_rgba(15,107,79,0.05)]">
          <h3 className="font-heading text-sm font-semibold text-[#1F2937]">Manasik Mendatang</h3>
          {data.upcoming_manasik.length === 0 ? (
            <p className="mt-3 text-sm text-[#64748B]">Belum ada jadwal manasik mendatang.</p>
          ) : (
            <div className="mt-3 space-y-3">
              {data.upcoming_manasik.map((e) => (
                <div key={e.id} data-testid={`guide-upcoming-manasik-${e.id}`} className="rounded-xl bg-[#F5F9F7] p-3">
                  <p className="text-sm font-medium text-[#1F2937]">{e.title}</p>
                  <p className="text-xs text-[#64748B]">{formatDate(e.date)} &middot; {e.time}</p>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="rounded-2xl bg-white p-5 shadow-[0_2px_10px_rgba(15,107,79,0.05)]">
          <h3 className="font-heading text-sm font-semibold text-[#1F2937]">Pengumuman</h3>
          {data.announcements.length === 0 ? (
            <p className="mt-3 text-sm text-[#64748B]">Belum ada pengumuman.</p>
          ) : (
            <div className="mt-3 space-y-3">
              {data.announcements.map((a) => (
                <div key={a.id} data-testid={`guide-announcement-${a.id}`} className="rounded-xl bg-[#F5F9F7] p-3">
                  <p className="text-sm font-medium text-[#1F2937]">{a.title}</p>
                  <p className="text-xs text-[#64748B] line-clamp-2">{a.content}</p>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
